// extracted by mini-css-extract-plugin
export default {"previewContent":"previewContent--e9_7M","collapse":"collapse--ReL_B","collapseContainer":"collapseContainer--ndlQS","collapseWrapperContent":"collapseWrapperContent--v0pKJ"};